import { useEffect, useState } from "react";
import API from "../../../../services/api";
import "./OTPVerification.css";

function OTPVerification({
  email,
  ownerName,
  businessName,
  isVerified,
  setIsVerified,
}) {

  const [otp, setOtp] = useState("");

  const [otpSent, setOtpSent] = useState(false);

  const [timer, setTimer] = useState(0);

  const [loading, setLoading] = useState(false);

  const [status, setStatus] = useState("");

  const [statusType, setStatusType] = useState("");

  // ==========================
  // Timer
  // ==========================

  useEffect(() => {

    let interval = null;

    if (otpSent && timer > 0) {

      interval = setInterval(() => {

        setTimer((prev) => prev - 1);

      }, 1000);

    }

    return () => {

      if (interval) clearInterval(interval);

    };

  }, [otpSent, timer]);

  // ==========================
  // Send OTP
  // ==========================

  const sendOTP = async () => {

    if (!email) {

      setStatus("Please enter your email first.");

      setStatusType("error");

      return;

    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {

      setStatus("Please enter a valid email.");

      setStatusType("error");

      return;

    }

    try {

      setLoading(true);

      await API.post(
    "/auth/send-email-otp",
    {
        email,
        ownerName,
        businessName,
        type: "provider-register",
    }
);

      setOtpSent(true);

      setTimer(30);

      setStatus("OTP sent successfully.");

      setStatusType("success");

    }

    catch (error) {

      setStatus(

        error.response?.data?.message ||

        "Unable to send OTP."

      );

      setStatusType("error");

    }

    finally {

      setLoading(false);

    }

  };

  // ==========================
  // Verify OTP
  // ==========================

  const verifyOTP = async () => {

    if (otp.length !== 6) {

      setStatus("Please enter the complete 6-digit OTP.");

      setStatusType("error");

      return;

    }

    try {

      setLoading(true);

      await API.post(

        "/auth/verify-email-otp",

        {

          email,

          otp,

        }

      );

      setIsVerified(true);

      setStatus("Email verified successfully.");

      setStatusType("success");

    }

    catch (error) {

      setStatus(

        error.response?.data?.message ||

        "Invalid OTP."

      );

      setStatusType("error");

    }

    finally {

      setLoading(false);

    }

  };

  return (

    <div className="otp-card">

      <h3>

        Email Verification

      </h3>

      {
  status &&
  !isVerified && (
    <div className={`otp-status ${statusType}`}>
      {status}
    </div>
  )
}

      {

        isVerified ? (

          <div className="verified-box">

            ✅ Email Verified Successfully

          </div>

        ) : (

          <>

            {

              !otpSent && (

                <button

                  type="button"

                  className="otp-btn"

                  onClick={sendOTP}

                  disabled={loading}

                >

                  {

                    loading

                      ? "Sending OTP..."

                      : "Send OTP"

                  }

                </button>

              )

            }

            {

              otpSent && (

                <>

                  <input

                    className="otp-input"

                    type="text"

                    placeholder="Enter 6-digit OTP"

                    maxLength={6}

                    value={otp}

                    onChange={(e) =>

                      setOtp(

                        e.target.value.replace(/\D/g, "")

                      )

                    }

                  />

                  <button

                    type="button"

                    className="verify-btn"

                    onClick={verifyOTP}

                    disabled={loading}

                  >

                    {

                      loading

                        ? "Verifying..."

                        : "Verify OTP"

                    }

                  </button>

                  {

                    timer > 0 ? (

                      <p className="timer">

                        Resend OTP in {timer}s

                      </p>

                    ) : (

                      <button

                        type="button"

                        className="resend-btn"

                        onClick={sendOTP}

                      >

                        Resend OTP

                      </button>

                    )

                  }

                </>

              )

            }

          </>

        )

      }

    </div>

  );

}

export default OTPVerification;